
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import util from "../../lib/util";
import appconst from "../../lib/appconst";
import url from "../../lib/url";
import sessionai from "../sessionai.vue";
import Util from "@/lib/util";
import {Sortable} from "sortablejs"
@Component({
  components: {},
})
export default class Homes extends AbpBase {
  waitDoList: Array<any> = new Array<any>();
  waitList: Array<any> = new Array<any>();
  newsList: Array<any> = new Array<any>();
  noticeList: Array<any> = new Array<any>();
  mineAppList: Array<any> = new Array<any>();
  commonAppList: Array<any> = new Array<any>();
  newCommonAppList: Array<any> = new Array<any>();
  appList: Array<any> = new Array<any>();
  tagList: Array<any> = new Array<any>();
  waitNewsList: Array<any> = new Array<any>();
  wid: number = 0;
  userInfo: Object = new Object();
  department: Object = new Object();
  org: Object = new Object();
  showPhone: boolean = false;
  showTips: boolean = false;
  showDownloadAPPQR: boolean = true;
  domainAccount: string = "";
  defaultImg: string = 'this.src="../../images/renyuan.png"'

  isIE = false;
  isChrome = false;
  activeTag: number = 0;
  answerList: Array<any> = new Array<any>();
  lanEn = false;
  // 应用程序当前tab
  currentTab: string = "all";
  haoqiUrl: string = "";
  isCanHaoqi: boolean = false;
  isCanBook: boolean = false;
  // 通讯录
  treeData: Array<any> = new Array<any>();
  txlUserList: Array<any> = new Array<any>();
  fliterTxlUser: Array<any> = new Array<any>();
  isShowWB: boolean = false;
  txlUserInfo: Object = new Object();
  lang: string = "zh-Hans";
  txlInputValue: string = "";
  isShowSerch: boolean = false;
  orgDate: Array<any> = new Array<any>();
  orgAllList: Array<Object> = new Array<Object>();
  treeId: number = null;
  // 员工必读
  menuList: Array<Object> = new Array<Object>();
  noReadData: Array<Object> = new Array<Object>();
  mustReadList: Array<Object> = new Array<Object>();
  activeMenuName: number = null;
  iframeWidth:number=0;
  iframeHeight:number=0;
  iframeRate:number=1.35;
  splitLeft:number=0.3;
  splitCenter:number=0.40;
  splitCenterBottom:number=0.55;
  splitRight:number=0.65;
  showModal:boolean=false;

  //it报修列表
  iscList: Array<any> = new Array<any>();

  tabValue: string = "all";
  
  showToolIT: boolean = false;
  updateTool: object = {};
  toolPics: Array<any> = new Array<any>();
  imagebox: boolean = false;
  rules = {
    question: [
      {
        required: true,
        message: this.L("标题不能为空"),
        trigger: "blur",
      },
    ],
    description: [
      {
        required: true,
        message: this.L("描述不能为空"),
        trigger: "blur",
      },
    ],
  };
  splitLeftChange(){
	 localStorage.setItem('splitLeft',this.splitLeft.toFixed(2));
  }
  splitCenterChange(){	  
	  localStorage.setItem('splitCenter',this.splitCenter.toFixed(2));
  }
  splitCenterBottomChange(){  	 
	  localStorage.setItem('splitCenterBottom',this.splitCenterBottom.toFixed(2));
  }
  splitRightChange(){
	   this.showModal=false;
	  localStorage.setItem('splitRight',this.splitRight.toFixed(2));
  }
  splitRightStart(){
	  this.showModal=true;
  }
  async upload(file) {
    let that = this;
    var form = new FormData();
    form.append("file", file);
    var res = await this.$store
      .dispatch({
        type: "app/uploadImage",
        data: form,
      })
      .then((res) => {
        that.toolPics.push(res);
        that.imagebox = true;
      });
  }
  handleRemove(index) {
    this.toolPics.splice(index, 1);
  }
  handleSuccess(res, file) {}
  handleUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();
    if (fileExt === "jpeg" || fileExt === "jpg" || fileExt === "png") {
      this.upload(file);
    } else {
      this.$Notice.warning({
        title: this.L("文件类型错误"),
        desc: this.L("文件不是图片").replace("{0}", file.name),
      });
    }
    return false;
  }
  async saveFile() {
    (this.$refs.toolForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$Message.loading({
          content: this.L("报修中"),
          duration: 0,
        });
        const params = Object.assign(
          {
            pictures: this.toolPics.join(","),
            type: 2,
          },
          this.updateTool
        );
        var res = await this.$store
          .dispatch({
            type: "app/createAnswer",
            data: params,
          })
          .then((res) => {
            if (res.success) {
  				this.$Message.success(this.L("报修提交成功"));
              this.cancelFile();
            } else {
              this.$Message.error(this.L("报修提交失败"));
            }
          })
          .finally(() => {
            this.$Message.destroy();
          });
      }
    });
  }
  cancelFile() {
    (this.$refs.toolForm as any).resetFields();
    this.updateTool = {};
    this.toolPics = [];
    this.showToolIT = false;
  }

  tabChange(e) {
    this.tabValue = e;
	if(this.newCommonAppList.length>0){
		this.commonAppList=JSON.parse(JSON.stringify(this.newCommonAppList));
	}
  }

  onImageError(event) {
    event.target.onerror = null;
    event.target.src = '/images/renyuan.png';
  }

  showMustReadDetail(item) {
    let user = JSON.parse(localStorage.getItem("userInfo"));
    let isen = this.lang == "zh-Hans" ? 0 : 1;
    window.open(
      "#/mustReadDetail?readid=" +
      item.id +
      "&isen=" +
      isen +
      "&userid=" +
      user.id
    );
  }

  async getMustReadClassify() {
    const params = {
      isAppUser: true,
      orderType: 1,
    };
    let newmenuList = await this.$store.dispatch({
      type: "app/getMustReadClassify",
      data: params,
    });
    let newnoReadData = await this.$store.dispatch({
      type: "app/getClassifyNoReadCount",
    });

    newmenuList &&
      newmenuList.items.forEach((menu) => {
        menu.count = 0;
        let fid = newnoReadData.find((item) => item.id == menu.id);
        if (fid) {
          menu.count += fid.count;
        }
        if (menu.childrenList) {
          menu.childrenList.forEach((menuSub) => {
            let fid = newnoReadData.find((item) => item.id == menuSub.id);
            if (fid) {
              menuSub.count = fid.count;
              menu.count += fid.count;
            }
          });
        }
      });
    this.menuList = newmenuList.items;

    this.activeMenuName = this.menuList[0].id;

    this.getMustRead(this.menuList[0].childrenList[0].id);

    // this.$refs.menu.updateOpened();
    // this.$refs.menu.currentActiveName = this.openMeneName
  }

  getMustRead(id) {
    const params = {
      skipCount: 0,
      maxResultCount: 10000,
      isAppUser: true,
      status: "OP",
      tagId: id,
      lang: abp.utils.getCookieValue("Abp.Localization.CultureName"),
    };
    this.$store
      .dispatch({
        type: "app/getMustRead",
        data: params,
      })
      .then((res) => {
        this.mustReadList = res.items || [];
      });
  }

  txlInputChange(e) {
    console.log("txlInputChange===========>", e);
    //this.txlInputValue = e;
    if (this.treeId) {
      //this.fliterTxl();
	  this.getUserByOrgId(this.treeId);
    } else {
      this.getUser();
    }
  }
  changeShowSearch() {
    this.isShowSerch = !this.isShowSerch;
    if (!this.isShowSerch) {
      this.txlInputValue = null;
    }
  }

  changeShowWB() {
    this.isShowWB = !this.isShowWB;
    if (this.treeId) {
      this.getUserByOrgId(this.treeId);
    } else {
      this.getUser();
    }
  }

  fliterTxl() {
    this.txlUserList = this.fliterTxlUser.filter((item) =>
      item.name.includes(this.txlInputValue)
    );
  }

  fliterTxlUserList() {
    if (this.treeId) {
      this.fliterTxl();
    } else {
      this.getUser();
    }
  }
  getTxlUserInfo(userId) {
    var that = this;
    var request = {
      id: userId,
    };
    this.$store
      .dispatch({
        type: "user/get",
        id: userId,
      })
      .then((res) => {
        that.txlUserInfo = res as any;
      });
  }
  toggle(index, user) {
    this.getTxlUserInfo(user.id);
    this.txlUserList.forEach((item, i) => {
      if (i == index && item.isShowInfo) {
        this.$set(this.txlUserList[i], "isShowInfo", false);
      } else {
        this.$set(this.txlUserList[i], "isShowInfo", i === index);
      }
    });
  }
  changeTreeId(item) {	 
    //this.treeId = item.id;
	console.log("changeTreeId")
	if (this.treeId) {
	  this.getUserByOrgId(this.treeId);
	} else {
	  this.getUser();
	}
  }  
  goHaoqi() {
    var curlurl = localStorage.getItem("curl_url");
    if (curlurl != "" && curlurl != "") {
      var t = Math.round(Math.random() * 10);
      curlurl += "&t=" + t;
      window.open(curlurl, "_blank");
    } else {
      if (url.toLocaleLowerCase().indexOf("gistest") > -1) {
        var user = JSON.parse(localStorage.getItem("userInfo"));
        curlurl =
          "https://gistest.yfpo.com:9158/#/sessionai2?userid=" + user.Id;
      } else {
        var user = JSON.parse(localStorage.getItem("userInfo"));
        curlurl = "https://gis.yfpo.com:9158/#/sessionai2?userid=" + user.Id;
      }
      var t = Math.round(Math.random() * 10);
      curlurl += "&t=" + t;
      console.log(curlurl);
      window.open(curlurl, "_blank");
    }
  }
  changeTag(tag) {
    this.currentTab = tag.id;
  }
  getWaitDoMsgByUserId() {
    var pagerequest = {
      MaxResultCount: 6,
      SkipCount: 0,
      Client: 2,
    };
    let that = this;
    this.$store
      .dispatch({
        type: "app/getWaitDoMsgByUserId",
        data: pagerequest,
      })
      .then((res) => {
      
        var newlist = res.items;
        // var waitNew = [];
        // for (var i = 0; i < newlist.length; i++) {
        //   for (var j = 0; j < that.commonAppList.length; j++) {
        //     if (that.commonAppList[j].id == newlist[i].appId) {
        //       if (that.commonAppList[j].supportDeviceTypes.indexOf("PC") > -1) {
        //         waitNew.push(newlist[i]);
        //       }
        //     }
        //   }
        // }
		
		var waitNew = [];
		
		for (var i = 0; i < newlist.length; i++) {			
			var has=false;			
			for (var j = 0; j < that.waitDoList.length; j++) {
			  if (that.waitDoList[j].appId == newlist[i].appId) {
				  has=true;
			    that.waitDoList[j].totalCount= newlist[i].totalCount;
				that.waitDoList[j].waitDoMsg=newlist[i].waitDoMsg;
			  }
			}
			if(!has){
				
				for (var j = 0; j < that.commonAppList.length; j++) {
				  if (that.commonAppList[j].id && newlist[i].appId== that.commonAppList[j].id) {
				    if (that.commonAppList[j].supportDeviceTypes.indexOf("PC") > -1) {
						that.waitDoList.push(newlist[i]);
				    }
				  }
				}
			}
		  
		}
		
		this.waitDoList.sort((a, b) => { return b.totalCount - a.totalCount  });
		
        // that.waitDoList = waitNew;
        var index = 0;
        if (that.waitDoList.length > 0) {
          if (that.wid > 0) {
            for (var i = 0; i < that.waitDoList.length; i++) {
              if (that.wid == that.waitDoList[i].appId) {
                index = i;
                // that.appName = that.waitDoList[i].appName;
              }
            }
          } else {
            // that.appName = that.waitDoList[0].appName;
            that.wid = that.waitDoList[0].appId;
            index = 0;
          }
        }
        //that.scrollView = that.appName;
        // console.log(that.waitList);
        that.changeApp(index);
      });
  }
  appDetail(index) {
    var app = this.commonAppList[index];
    if (app.isfixed) {
      //固定菜单，直接跳转
      if (app.name == "员工必读") {
        window.open("#/mustreadList");
      }
    } else {
      this.checkBrowser();
      var supportBrowsers = [];
      if (app.property != null) {
        supportBrowsers = app.property.SupportBrowsers;
      } else {
        supportBrowsers = app.supportDeviceTypes;
      }
      var url = app.startUrl;
      var browser = "";
      console.log(url);

      if (
        this.isIE &&
        supportBrowsers.length == 1 &&
        supportBrowsers[0].toLowerCase() == "chrome"
      ) {
        url = "openChrome:" + url;
        browser = "Chrome";
      }
      if (
        this.isChrome &&
        supportBrowsers.length == 1 &&
        supportBrowsers[0].toLowerCase() == "ie"
      ) {
        url = "openIE:" + url;
        browser = "IE";
      }

      if (browser != "") {
        var alerthtml =
          "温馨提示 Notice \\n该应用需使用" +
          browser +
          "浏览器才可访问，如仅见此页面，说明调用" +
          browser +
          "浏览器功能异常 \\n请手工打开" +
          browser +
          "浏览器登录GIS主页，再点击应用图标进行访问！\\nThe application needs to use " +
          browser +
          " browser to work normally. If you only see this page, it indicates that calling " +
          browser +
          " browser function is abnormal.\\nPlease manually open the  " +
          browser +
          " browser, log in to the GIS home page, and then click the application icon to access.";

        var newpage = window.open(url);

        setTimeout(function () {
          newpage.document.write(
            '<script> setTimeout(function(){if(document.body==null || document.body.innerHTML.trim()==""){alert("' +
            alerthtml +
            '");window.close(); }   },"4000");  </' +
            "script>"
          );
        }, 4000);
      } else {
        window.open(url);
      }
    }
  }
  checkBrowser() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) this.isIE = true;
    if (window.navigator.userAgent.indexOf("Chrome") != -1) {
      this.isChrome = true;
    }
  }
  gotoApp(index) {
    var item = this.waitList[index];
    console.log(item);
    var that = this;
    var idpToken = localStorage.getItem("idptoken");
    //localStorage.setItem("website", "W3Cfuns.com"); location.getStorageSync uni.getStorageSync("idptoken");
    var url = this.changeUrlArg(item.url, "access_token", idpToken);

    var url2 = this.changeUrlArg(url, "domain", that.domainAccount);

    console.log("gotoApp===url2===>", url2);

    window.open(url2);
    // uni.navigateTo({
    // 	url: '/pages/webview/webview?path=' + encodeURIComponent(url)
    // });
  }
  changeUrlArg(url, arg, val) {
    var pattern = arg + "=([^&]*)";
    var replaceText = arg + "=" + val;
    return url.match(pattern)
      ? url.replace(eval("/(" + arg + "=)([^&]*)/gi"), replaceText)
      : url.match("[\?]")
        ? url + "&" + replaceText
        : url + "?" + replaceText;
  }
  newsTO3Col() {
    const columns = 3;
    const result = Array.from({ length: columns }, () => []);
    this.answerList.forEach((item, index) => {
      result[index % columns].push(item);
    });
    return result;
  }
  getNewsList() {
    var that = this;
    var pageNewsRequest = {
      SkipCount: 0,
      MaxResultCount: 6,
      TagType: 4,
      Status: "OP",
      // TagId: 4,
    };
    this.$store
      .dispatch({
        type: "app/getNewsList",
        data: pageNewsRequest,
      })
      .then((res) => {
       
		var list=[];
        for (var i = 0; i < res.items.length; i++) {
          if (res.items[i].coverImg != null) {
            res.items[i].coverImg = res.items[i].coverImg.replace(
              "http:",
              "https:"
            );
          }
          list.push(res.items[i]);
        }
		 that.newsList = list;
      });
  }
  getISCList() {
    var that = this;
    this.$store
      .dispatch({
        type: "app/getISCList"
      })
      .then((res) => {
		 
        that.iscList = res;
      });
  }
  getNoticeList() {
    var that = this;
    var pageNoticeRequest = {
      SkipCount: 0,
      MaxResultCount: 6,
      // TagType: 4,
      // TagId: 7,
    };
    this.$store
      .dispatch({
        type: "app/getWaitDoNewsByUserID",
        data: pageNoticeRequest,
      })
      .then((res) => {
		var list=[];
        for (var i = 0; i < res.items.length; i++) {
          if (res.items[i].coverImg != null) {
            res.items[i].coverImg = res.items[i].coverImg.replace(
              "http:",
              "https:"
            );
          }

         list.push(res.items[i]);
        }
		that.noticeList=list;
        //that.noticeList = res.items;
      });
  }
  getApplicationList() {
    var that = this;
    var pageAppRequest = {
      SkipCount: 0,
      MaxResultCount: 100,
    };
    this.$store
      .dispatch({
        type: "app/getApplicationList",
        data: pageAppRequest,
      })
      .then((res) => {
        that.appList = [];
        var appList = res.items;
        // console.log(appList);
        var list_tag = [];
        for (var i = 0; i < appList.length; i++) {
          that.appList.push(appList[i]);
          if (appList[i].showAPP) {
            var arr = new Object() as any;
            arr.id = appList[i].tagId + "";
            if (appList[i].tag != null) {
              arr.tagName = appList[i].tag.key;
			  list_tag.push(arr);
            }
            
          }
        }
        var temp = {}; //用于name判断重复
        var result = [
          {
            id: "all",
            tagName: "全部",
          },
        ]; //最后的新数组
        list_tag.map(function (item, index) {
          if (!temp[item.id]) {
            result.push(item);
            temp[item.id] = true;
          }
        });
		console.log(result);
        that.tagList = result;
        that.getApplicationByUser();
      });
  }
  getApplicationByUser() {
    var that = this;

    that.mineAppList = [];
    this.$store
      .dispatch({
        type: "app/getApplicationByUserId",
        data: {},
      })
      .then((res) => {
        if (res.data.success) {
          // console.log(JSON.stringify(res.data.result))
          localStorage.removeItem("idpRetryTimes");
          var curlUrl = "";
		  var msort=0;
          for (var i = 0; i < res.data.result.length; i++) {
            // if ((res.data.result[i].supportDeviceTypes.indexOf("WEB") > -1 ||
            // 		res.data.result[i].supportDeviceTypes.indexOf("PC") > -1) &&
            // 	res.data.result[i].applicationId != 'yfjwt5' &&
            // 	res.data.result[i].enabled && res.data.result[i].display) {
            // 	that.mineAppList.push(res.data.result[i]);
            // }
			if(res.data.result[i].description && (res.data.result[i].description.toLowerCase().startsWith("saml") || res.data.result[i].description.toLowerCase().startsWith("oauth2")) ){
				res.data.result[i].pageSort=msort;
				that.mineAppList.push(res.data.result[i]);
				msort++;
			}
            else if (
              res.data.result[i].supportDeviceTypes.indexOf("PC") > -1 &&
              res.data.result[i].applicationId != "yfjwt5" &&
              res.data.result[i].enabled &&
              res.data.result[i].display
            ) {
				
				res.data.result[i].pageSort=msort;
              that.mineAppList.push(res.data.result[i]);
			  msort++;
            }
            if (
              window.location.hostname.toLocaleLowerCase().indexOf("gistest") >
              -1
            ) {
              if (res.data.result[i].applicationId == "yfjwt2") {
                curlUrl = res.data.result[i].startUrl;
              }
            } else if (res.data.result[i].applicationId == "yfjwt38") {
              curlUrl = res.data.result[i].startUrl;
            }
            if (url.indexOf("gistest.yfpo.com") != -1) {
              //测试
              if (res.data.result[i].applicationId == "yfjwt2") {
                that.haoqiUrl = res.data.result[i].startUrl;
              }
            } else {
              //正式
              if (res.data.result[i].applicationId == "yfjwt38") {
                that.haoqiUrl = res.data.result[i].startUrl;
              }
            }
          }
          for (var i = 0; i < that.appList.length; i++) {
            that.appList[i].isClick = false;
            for (var j = 0; j < that.mineAppList.length; j++) {
              if (that.appList[i].code == that.mineAppList[j].applicationId) {
                that.appList[i].isClick = true;
				
                that.appList[i].url = that.mineAppList[j].startUrl;
                that.mineAppList[j].logoUrl = that.appList[i].logoUrl.replace(
                  "http:",
                  "https:"
                );
				
				
				that.mineAppList[j].apiUrl=that.appList[i].apiUrl;

                that.mineAppList[j].tagId = that.appList[i].tagId;
                that.mineAppList[j].id = that.appList[i].id;
                if (
                  that.appList[i].property == null ||
                  that.appList[i].property == ""
                )
                  that.appList[i].property = "{}";
                that.mineAppList[j].property = JSON.parse(
                  that.appList[i].property
                );
              }
            }
            if (!that.appList[i].isClick) {
              that.appList[i].url = "";
            }
          }
		  
		  var waitNew = [];
		  
		 
		  
          that.commonAppList = that.mineAppList;
          localStorage.setItem("curl_url", that.haoqiUrl);
		   console.log(that.commonAppList)
		  var sortable= new Sortable(document.getElementById('app-contant-tab-pane'), {
			  animation: 300, // 动画时间，单位毫秒
			  ghostClass: 'sortable-ghost', // 拖动时的幽灵类名
			  onEnd: function (/**Event*/evt) { // 当拖拽结束时触发的事件
				  const itemEl = evt.item; // 当前被拖拽的元素
				  const newsort=evt.newIndex;
				  const oldsort=evt.oldIndex;
				  const appid=itemEl.id.toString();
				  const code=itemEl.getAttribute("code");
				  const index = parseInt(itemEl.getAttribute("index"));
				  
				  console.log(appid+","+code+","+newsort+","+oldsort);
				  var kkst=0;
				 
				  for(var p=0;p<that.commonAppList.length;p++){
					  if(appid == that.commonAppList[p].id.toString()){
					  	that.commonAppList[p].pageSort=JSON.parse(JSON.stringify(newsort));	
					  }
					  else{
						  if(newsort>oldsort){							 
							  if(that.commonAppList[p].pageSort>=oldsort && that.commonAppList[p].pageSort<=newsort){
								that.commonAppList[p].pageSort=that.commonAppList[p].pageSort-1;		
							  }		
						  }
						  else{							
						  	if(that.commonAppList[p].pageSort>=newsort && that.commonAppList[p].pageSort<oldsort){
						  		that.commonAppList[p].pageSort=that.commonAppList[p].pageSort+1;		
						  	}
						  }
					  }
					  
				  }
				 
				 //  that.commonAppList.forEach((item) => {				   
					// if(appid == item.id.toString()){
					// 	item.pageSort=JSON.parse(JSON.stringify(newsort));	
					// }
					// else{
					// 	if(newsort>oldsort){
					// 		if (item.pageSort>=newsort) {
					// 		   item.pageSort=JSON.parse(JSON.stringify(item.pageSort-1));					   
					// 		}
					// 	}
					// 	else{							
					// 		if (item.pageSort<oldsort) {
					// 		   item.pageSort=JSON.parse(JSON.stringify(item.pageSort-1));			   
					// 		}
					// 	}
					
					// }					
				 //  });
				 
				 var newls= JSON.parse(JSON.stringify(that.commonAppList))
				  that.newCommonAppList = newls.sort((a,b)=>{
				  		return a.pageSort - b.pageSort;
				  })
				  
				  // that.newCommonAppList.forEach((item) => {
				  //   console.log("---------"+ item.id+","+item.name+","+item.pageSort)
				  // });
				  that.$forceUpdate();
				  //console.log(that.commonAppList)
				  that.setUserApplicationsSortWeb()
			  },			 
		  });
		
		  for (var j = 0; j < that.commonAppList.length; j++) {
		    if (that.commonAppList[j].id) {
		      if (that.commonAppList[j].supportDeviceTypes.indexOf("PC") > -1 && that.commonAppList[j].apiUrl!=null && that.commonAppList[j].apiUrl!='') {
				  that.commonAppList[j].appId=that.commonAppList[j].id;
				  that.commonAppList[j].appName=that.commonAppList[j].name;
				  that.commonAppList[j].appLogo=that.commonAppList[j].logoUrl;
				  that.commonAppList[j].appUrl=that.commonAppList[j].url;
				  that.commonAppList[j].totalCount=0;
				  that.commonAppList[j].waitDoMsg=[];
						  
		        waitNew.push(that.commonAppList[j]);
		      }
		    }
		  }
		  
		  that.waitDoList = waitNew;

          this.getWaitDoMsgByUserId();
		
		  
		 
          // that.setCommonApps();
        } else if (res.data.error.code == 1) {
          this.$store.commit("/app/logout", this);
          util.abp.auth.clearToken();
          if (
            window.location.hostname.toLocaleLowerCase().indexOf("gistest") > -1
          ) {
            window.location.href =
              "https://gistest.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgistest.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt13%3FenterpriseId%3Dyf";
          } else {
            if (window.location.port == "9185") {
              window.location.href =
                "https://gis.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgis.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt70%3FenterpriseId%3Dyf";
            } else {
              window.location.href =
                "https://gis.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgis.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt5%3FenterpriseId%3Dyf";
            }
          }
		  
		  
		  
          // window.location.href = appconst.gisLogout;
          // 		debugger;
          // 		var times =  localStorage.getItem("idpRetryTimes") as any;

          // 		if (times && times > 2) {
          // 			this.$Message.error("token异常,请联系管理员");
          // 			return;
          // 		}
          // 		if (!times) {
          // 			times = 1;
          // 		}
          // 		times = times + 1;
          // 		localStorage.setItem("idpRetryTimes", times);
        }
      });
  }
  
  setUserApplicationsSortWeb(){
	var that = this;
	var newlist=[];
	
	that.newCommonAppList.forEach((item) => {
	 newlist.push({
		 id:item.id,
		 code:item.applicationId,
		 sort:item.pageSort
	 })
	});
	
	this.$store.dispatch({
	    type: "app/setUserApplicationsSortWeb",
	    data: newlist,
	  })
	  .then((res) => {
	   
	  });  
  }

  setCommonApps() {
    var that = this;
    //localStorage.setItem('companyid', session.companyid);
    const local_data_str = localStorage.getItem("local_data");
    var local_data =
      local_data_str != null ? JSON.parse(local_data_str) : new Array<any>();
    var tmpList = [];
    if (local_data.length > 0) {
      for (var j = 0; j < local_data.length; j++) {
        var exists = false;
        var eachlocal = local_data[j] as any;
        for (var i = 0; i < that.mineAppList.length; i++) {
          var eachmine = that.mineAppList[i] as any;
          if (eachmine.applicationId == eachlocal.applicationId) {
            eachlocal.startUrl = eachmine.startUrl;
            eachlocal.logoUrl = eachmine.logoUrl.replace("http:", "https:");
            exists = true;
            break;
          }
        }
        if (exists) {
          tmpList.push(eachlocal);
        }
      }
      // that.initStorageData();
    } else {
      //第一次获取我的应用
      // that.initStorageData();
      // uni.setStorage({
      // 	key: 'local_data',
      // 	data: that.mineAppList,
      // 	success: function(e) {
      // 		that.mineAppList = uni.getStorageSync('local_data');
      // 		// console.log(e);
      // 	}
      // });
      tmpList = that.mineAppList;
    }
    localStorage.setItem("local_data", JSON.stringify(tmpList));
    that.commonAppList = tmpList;
    // that.setCommonTag(tmpList);
  }
  getWaitNewsApplication() {
    var that = this;
    var request = {
      SkipCount: 0,
      MaxResultCount: 1000,
      UnRead: false,
    };

    this.$store
      .dispatch({
        type: "app/getWaitNewsApplication",
        data: request,
      })
      .then((res) => {
        that.appList = res.items;
        if (that.appList.length > 0) {
          that.wid = that.appList[0].id;
          that.getWaitDoNewsByUserID();
        }
      });
  }
  getWaitDoNewsByUserID() {
    var that = this;
    var request = {
      SkipCount: 0,
      MaxResultCount: 20,
      AppId: that.wid,
    };
    this.$store
      .dispatch({
        type: "app/getWaitDoNewsByUserID",
        data: request,
      })
      .then((res) => {
        // console.log(res.items);
        that.waitNewsList = res.items;
        for (var i = 0; i < that.waitNewsList.length; i++) {
          that.waitNewsList[i].datetime = Util.formatDate(new Date(), "hh:mm");
          that.waitNewsList[i].creationTime = Util.formatDate(
            new Date(that.waitNewsList[i].creationTime),
            "yyyy-MM-dd hh:mm:ss"
          );
        }
      });
  }
  showNewsDetail(newid) {
    window.open("#/newsdetail?newid=" + newid);
    // this.$router.push({
    // 	path: '/newsdetail',
    // 	query: {
    // 		newid: newid
    // 	}
    // })
  }
  showIscDetail(incidentNumber){
    window.open("#/iscdetail?incidentNumber=" + incidentNumber);
  }
  showAnswerDetail(aid) {
    window.open("#/answerDetail?aid=" + aid);
    // this.$router.push({
    // 	path: '/newsdetail',
    // 	query: {
    // 		newid: newid
    // 	}
    // })
  }
  showNewsList() {
    window.open("#/newsList");
  }
  showNoticeList() {
    window.open("#/noticeList");
  }
  showAnswerList() {
    window.open("#/answerList?tid=" + this.activeTag);
  }
  changeApp(index) {
    var that = this;
    that.waitList = new Array();
    var eachinfo = that.waitDoList[index];
    if (eachinfo != undefined) {
      that.wid = eachinfo.appId;
      for (var j = 0; j < eachinfo.waitDoMsg.length; j++) {
        var each = eachinfo.waitDoMsg[j];
        each.name = eachinfo.appName;
        each.logo = eachinfo.appLogo;
        // each.datetime = that.formatDate(new Date(), "hh:mm");
        each.time = Util.formatDate(new Date(each.time), "yyyy-MM-dd hh:mm:ss");
        that.waitList.push(each);
      }
    }

    //that.scrollView=eachinfo.appName;
  }
  getLoginUser() {
    var that = this;
    this.$store
      .dispatch({
        type: "app/getLoginUser",
        data: {},
      })
      .then((res) => {
        // console.log("loginuser");
        console.log(res);
        that.userInfo = res;
        that.isCanBook = res.isExternal;
        var phonenumber = res.phoneNumber;
        that.getLoginUserDomainAccount(phonenumber);

        (that.userInfo as any).namedd = (that.userInfo as any).name;
        (that.userInfo as any).postdd = (that.userInfo as any).chPost;
        if (abp.localization.currentLanguage.name == "en") {
          (that.userInfo as any).namedd = (that.userInfo as any).eName;
          (that.userInfo as any).postdd = (that.userInfo as any).enPost;
        }

        localStorage.setItem("userInfo", JSON.stringify(res));
        //that.getUser(that.userInfo.id);
        if ((that.userInfo as any).rootOrganization != null) {
          that.org = (that.userInfo as any).rootOrganization;


          (that.org as any).namedd = (that.org as any).displayName;
          if (abp.localization.currentLanguage.name == "en") {
            (that.org as any).namedd = (that.org as any).enName;
          }
        }
        if (
          (that.userInfo as any).organizations != null &&
          ((that.userInfo as any).organizations as any).length > 0
        ) {
          for (
            var i = 0;
            i < ((that.userInfo as any).organizations as any).length;
            i++
          ) {
            if (
              (that.userInfo as any).organizations[i].parentId != null &&
              (that.userInfo as any).organizations[i].parentId > 0
            ) {
              that.department = (that.userInfo as any).organizations[i];

              (that.department as any).namedd = (
                that.department as any
              ).displayName;
              if (abp.localization.currentLanguage.name == "en") {
                (that.department as any).namedd = (
                  that.department as any
                ).enName;
              }
            } else {
              that.org = (that.userInfo as any).organizations[i];

              (that.org as any).namedd = (that.org as any).displayName;
              if (abp.localization.currentLanguage.name == "en") {
                (that.org as any).namedd = (that.org as any).enName;
              }
            }
          }
        }

        that.treeId = (that.department as any).id;
        that.getUserByOrgId(that.treeId);

        if ((that.userInfo as any).post == null) {
          (that.userInfo as any).post = "";
        }
      });
  }
  getLoginUserDomainAccount(phonenumber) {
    var that = this;
    this.$store
      .dispatch({
        type: "user/getUserByUserName",
        data: {
          name: phonenumber,
        },
      })
      .then((res2) => {
        that.domainAccount = res2.domainAccount;
        console.log("domainAccount:" + that.domainAccount);
      });
  }

  // getUser(id) {
  //   var that = this;
  //   this.$store
  //     .dispatch({
  //       type: "app/getUser",
  //       id: id,
  //     })
  //     .then((res) => {
  //       // console.log("getuser");
  //       // console.log(res);
  //       // that.user=res;
  //       // for (var i = 0; i < that.user.organizations.length; i++) {
  //       // 	if (that.user.organizations[i].parentId != null && that.user.organizations[i].parentId > 0) {
  //       // 		that.department = that.user.organizations[i];
  //       // 	} else {
  //       // 		that.org = that.user.organizations[i];
  //       // 	}
  //       // }
  //     });
  // }
  getIDSToken() {
    var that = this;
    this.$store
      .dispatch({
        type: "app/getIDSToken",
        data: {},
      })
      .then((res) => {
        localStorage.setItem("idptoken", res);
      });
  }
  async getAnsterTagList() {
    var that = this;
    var request = new Object() as any;
    request.maxResultCount = 1000;
    request.skipCount = 0;
    request.type = 7;

    this.$store
      .dispatch({
        type: "tag/getAllList",
        data: request,
      })
      .then((res) => {
        console.log(res);
        var result = res.items;
        var k = 0;
        for (var i = 0; i < result.length; i++) {
          if (result[i].key != null && result[i].key.trim() == "HotQuestions") {
            that.activeTag = result[i].id;
            k = i;
          }
        }
        if (that.activeTag > 0) {
          result.splice(k, 1);
          that.getAnswerList();
        }
      });
  }
  getAnswerList() {
    var that = this;
    var request = new Object() as any;
    request.maxResultCount = 10;
    request.skipCount = 0;
    request.status = 3;
    request.tagId = that.activeTag;
    request.IsAppUser = true;

    var languageName = "";
    console.log(that.lanEn);
    if (abp.localization.currentLanguage.name != "en") {
      languageName = "zh-Hans";
      that.lanEn = false;
    } else {
      languageName = "en";
      that.lanEn = true;
    }
    request.Lang = languageName;
    this.$store
      .dispatch({
        type: "tag/getAnswerAllList",
        data: request,
      })
      .then((res) => {
        console.log(res);
        var result = res.items;
        var answerList = [];
        for (var i = 0; i < result.length; i++) {
          answerList.push(result[i]);
        }
        that.answerList = answerList;

        const newanswerList = that.newsTO3Col();
        console.log(" this.answerList====>", newanswerList);
      });
  }
  getQueryVariable(p) {
    var query = window.location.search.substring(1);
    if (query == "") {
      var hashs = window.location.hash.split("?");
      if (hashs.length > 1) {
        query = hashs[1];
      }
      if (query.indexOf("#") > -1) {
        query = query.split("#")[0];
      }
    }
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == p) {
        return pair[1];
      }
    }
    return false;
  }


  created() {
    var that = this;
    if (abp.utils.getCookieValue("Abp.Localization.CultureName") == "en") {
      that.lang = "en";
    } else {
      that.lang = "zh-Hans";
    }

    var appCode = this.getQueryVariable("appCode");
    if (appCode != undefined && appCode != "") {
      this.checkBrowser();
      var that = this;
      this.$store
        .dispatch({
          type: "app/getAppByCode",
          data: {
            code: appCode,
          },
        })
        .then((res) => {
          var app = res.data.result;
          var supportBrowsers = JSON.parse(app.property).SupportBrowsers;
          var url = app.url;
          if (
            this.isIE &&
            supportBrowsers.length == 1 &&
            supportBrowsers[0].toLowerCase() == "chrome"
          ) {
            url = "openChrome:" + url;
          }
          if (
            this.isChrome &&
            supportBrowsers.length == 1 &&
            supportBrowsers[0].toLowerCase() == "ie"
          ) {
            url = "openIE:" + url;
          }
          location.href = url;
        });
    } else {
      that.pageLoad();
	  setInterval(function () {
	    let authTime = (localStorage as any).getItem("authTime") * 1;
	    var span = new Date().getTime() - authTime;
	    console.log(span);
	    if (span * 1 > 1000 * 60 * 20) {
	      that.pageLoad();
	      //window.location.reload();
	    }
	  }, 1000 * 60 * 20);
	  
	  if(localStorage.getItem("splitCenterBottom")){
		  this.splitCenterBottom= parseFloat(localStorage.getItem("splitCenterBottom")) ;
	  }
	  if(localStorage.getItem("splitCenter")){
	  	  this.splitCenter= parseFloat(localStorage.getItem("splitCenter")) ;
	  }
	  
	  if(localStorage.getItem("splitLeft")){
	  	  this.splitLeft= parseFloat(localStorage.getItem("splitLeft")) ;
	  }
	  else{
		  var ft=210/(window.innerHeight-50);
		  this.splitLeft=ft;
	  }
	  
	  if(localStorage.getItem("splitRight")){
	  	  this.splitRight= parseFloat(localStorage.getItem("splitRight")) ;
	  }
	  else{
		  
		  this.iframeWidth=window.innerWidth*0.25-26;
		  if(this.iframeWidth*this.iframeRate<500){
		  	this.iframeHeight=window.innerHeight*0.55;
		  }
		  else{
		  	this.iframeHeight=this.iframeWidth*this.iframeRate;
		  }
		  console.log("iframeHeight:"+ this.iframeHeight)
		  
		  var ft=(this.iframeHeight+100)/(window.innerHeight-50);
		  this.splitRight=ft;
	  }
	  
	 
	
	  
      setTimeout(function () {
        //删除链接domain参数
        that.replaceHashParameter("domain");
		
		that.replaceHashParameter("id_token");
      }, 1000);
      //this.getWaitNewsApplication();
     
    }
  }

  dataToTree(data, pid = null) {
    if (!Array.isArray(data) || !data.length) return [];
    let newOrgs = [];
    data.forEach((item) => {
      item.label =
        abp.localization.currentLanguage.name != "en"
          ? item.displayName
          : item.enName;
      if (item.parentId == pid) {
        let childrenData = this.dataToTree(data, item.id);
        if (childrenData.length > 0) {
          newOrgs.push({
            ...item,
            children: childrenData,
          });
        } else {
          newOrgs.push({
            ...item,
          });
        }
      }
    });
    return newOrgs;
  }

  getOrgDate(data) {
    let productTypeList = data; // 这个就是后台拿到的数据data
    // 删除所有 children,以防止多次调用(这一步是最后执行完之后加上的,因为不删除会多次调用)
    productTypeList.forEach((el) => {
      delete el.children;
    });

    let map = {};
    productTypeList.forEach((el) => {
      map[el.id] = el; // 循环data拿到所有的id
    });

    let arr = [];
    productTypeList.forEach((el) => {
      let parent = map[el.parentId]; // 拿到所有的pid,如果为真,和id进行对比,如果pid===id,就说明是id的子集

      if (parent) {
        (parent.children || (parent.children = [])).push(el);
      } else {
        // 如果不是就是第一级,没有pid或者pid为0
        arr.push(el);
        // console.log('arr', arr)
      }
    });
    return arr;
  }

  setAllOrg(obj) {
    var that = this;
    var newData = [];
    for (let i = 0; i < that.orgAllList.length; i++) {
      var each = that.orgAllList[i] as any;
      newData.push({
        id: each.id,
        parentId: each.parentId,
        title: each.displayName,
        checked: false,
        label:
          abp.localization.currentLanguage.name != "en"
            ? each.displayName
            : each.enName,
      });
    }
    that.orgDate = that.getOrgDate(newData);
  }

  getBookList() {
    var that = this;
    that.$store
      .dispatch({
        type: "user/getOrganizationList",
        data: {
          SkipCount: 0,
          MaxResultCount: 1000,
          Keyword: "",
          ParentId: 0,
          Top: false,
          IsAppUser: false,
        },
      })
      .then((res) => {
        if (res.success) {
          var orgList = res.result.items;
          that.orgAllList = orgList;
          that.setAllOrg("");

          let topList = [];
          orgList.forEach((item) => {
            if (!item.parentId) {
              topList.push(item);
            }
          });

          this.treeData = this.dataToTree(orgList);
          // that.orgList = newOrgs;
          // that.orgs = newOrgs;
          // that.orgs = that.getOrgTreeData();
        }
      });
  }
  // 部门联系人
  async getUser() {
    let params = {
      maxResultCount: 10000,
      skipCount: 0,
      hasOrgTop: this.txlInputValue ? false : true,
      source: this.isShowWB ? "GAC" : "",
      keyWord: this.txlInputValue,
    };
    await this.$store.dispatch({
      type: "user/getAll",
      data: params,
    });
    let newDataList = JSON.parse(JSON.stringify(this.$store.state.user.list));
    let dataList = newDataList.map((item) => {
      return {
        ...item,
        isShowInfo: false,
      };
    });
    this.txlUserList = dataList;
    this.fliterTxlUser = dataList;
  }

  // 根据部门id查询联系人
  async getUserByOrgId(id) {
    let params = {
      organizationUnitId: id,
      source: this.isShowWB ? "GAC" : "",
	  nameOrPhone:this.txlInputValue
    };
    await this.$store
      .dispatch({
        type: "user/getOrganizationListById",
        data: params,
      })
      .then((res) => {
        if (res.success) {
          let dataList = res.result.map((item) => {
            return {
              ...item,
              isShowInfo: false,
            };
          });
          this.txlUserList = dataList;
          this.fliterTxlUser = dataList;
        }
      });
  }

  getUserAuth() {
    this.$store
      .dispatch({
        type: "app/getAll",
      })
      .then((res) => {
        console.log(
          "res.auth.grantedPermissions.AppAIUser==========>",
          res.auth.grantedPermissions.AppAIUser
        );
        if (
          res.auth.grantedPermissions &&
          res.auth.grantedPermissions.AppAIUser &&
          res.auth.grantedPermissions.AppAIUser != undefined &&
          res.auth.grantedPermissions.AppAIUser.toLowerCase() == "true"
        ) {
          this.isCanHaoqi = true;
        } else {
          this.isCanHaoqi = false;
        }
      });
  }

  pageLoad() {
    this.getIDSToken();
    this.getLoginUser();
    this.getUserAuth();
    //this.getWaitDoMsgByUserId();
    //this.getNewsList();
    this.getNoticeList();
    this.getApplicationList();
    this.getAnsterTagList();
    this.getBookList();
    //this.getUser();



    // this.getMustReadClassify();
    this.getISCList();
  }

  @Watch("$route")
  routechange(to: any, from: any) {
    console.info("routechange---------------", to.query, from);
  }
  replaceHashParameter(paramKey) {
    let route = this.$router.currentRoute;
    if (route.query.hasOwnProperty(paramKey)) {
      delete route.query[paramKey];
      // route.query[paramKey]=""
      //route.query["time"] = new Date().getTime();

      const newQuery = {
        ...route.query,
        time: new Date().getTime(),
      };
      // 使用 `this.$router.push` 来更新 URL 的 query 部分，但不会导航到一个新的路由
      this.$router.push({
        path: this.$route.path,
        query: newQuery,
      });
    }
    // 使用URL对象获取当前URL
    var url = new URL(window.location.href);
    if (url.searchParams.has(paramKey)) {
      // 删除指定的查询参数
      url.searchParams.delete(paramKey);
      // 用新的URL替换当前页面的地址
      window.history.pushState({}, "", url.toString());
    }
  }

  formatStringToDate(dateString, fmt) {
    dateString = dateString.substr(0, 19);
    dateString = dateString.replace(/-/g, "/").replace(/T/g, " ");
    var date = new Date(dateString);
    return this.formatDate(date, fmt);
  }
  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    // // #ifdef APP-PLUS
    // date.setHours(date.getHours()-8);
    // // #endif
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : this.padLeftZero(str)
        );
      }
    }
    return fmt;
  }
  padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }
}
